export const invitroPharmacologySearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance'
  },
  {
    'value': '^root_createdDate',
    'display': 'Oldest Creation'
  },
  {
    'value': '$root_createdDate',
    'display': 'Newest Creation'
  },
  {
    'value': '^root_modifiedDate',
    'display': 'Oldest Change'
  },
  {
    'value': '$root_modifiedDate',
    'display': 'Newest Change'
  }
  /*,
  {
    'value': '^root_targetName',
    'display': 'Target Name, A-Z',
    'displayedColumns': 'assayTarget',
    'direction': 'asc'
  },
  {
    'value': '$root_targetName',
    'display': 'Target Name, Z-A',
    'displayedColumns': 'assayTarget',
    'direction': 'desc'
  }*/
];
